import { Button } from "@digdir/designsystemet-react";

interface ErrorButtonProps {
    variant: "primary" | "secondary";
    onClick: () => void;
    children: React.ReactNode;
}

export function ErrorButton({ variant, onClick, children }: ErrorButtonProps) {
    return (
        <Button 
            variant={variant}
            onClick={onClick}
            className="min-w-[120px]"
        >
            {children}
        </Button>
    );
}
